export const defaultAppConfig = {
  app_name: "DadDeck",
  app_description: "DadDeck is a playful single-page web app that serves up an endless stream of AI-powered Dad jokes, lets authenticated users save favorites to a personal library, and share laughs on Twitter with one click.",
  app_tagline: "Stack Your Dad Jokes",
  production: process.env.NODE_ENV === "production",
  app_url: process.env.APP_URL || "",
  app_id: process.env.APP_ID || "",
  
  app_logo_url_light:
    "https://app-assets.constructr.ai/f7a1ff32-4e5e-43a6-82ad-30f3434a818b/branding/logo-light.png",
  app_logo_url_dark:
    "https://app-assets.constructr.ai/f7a1ff32-4e5e-43a6-82ad-30f3434a818b/branding/logo-dark.png",

  app_full_logo_url_light:
    "https://app-assets.constructr.ai/f7a1ff32-4e5e-43a6-82ad-30f3434a818b/branding/logo-full-light.png",
  app_full_logo_url_dark:
    "https://app-assets.constructr.ai/f7a1ff32-4e5e-43a6-82ad-30f3434a818b/branding/logo-full-dark.png",

  app_badge_show: true,
  app_badge_href: "https://constructr.ai?utm_source=badge&utm_campaign=badge",
  app_badge_src: "https://assets.constructr.ai/images/made-with-badge.png",
  app_badge_alt: "Made with Constructr",
  allow_remix: false
};



